import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPackAmountWidgetStyles = (props, isSmallScreen) => {
  var _props$alignment = props.alignment,
    alignment = _props$alignment === void 0 ? 'center' : _props$alignment,
    _props$withRoundImage = props.withRoundImage,
    withRoundImage = _props$withRoundImage === void 0 ? false : _props$withRoundImage;
  return StyleSheet.create({
    container: {
      alignItems: alignment == 'center' ? 'center' : 'flex-start'
    },
    strikedText: {
      textDecorationLine: 'line-through',
      marginLeft: tokens.spacing.SPACING_4
    },
    infoTag: {
      marginTop: isSmallScreen ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_12,
      alignSelf: alignment == 'center' ? 'center' : 'flex-start'
    },
    planName: {
      flex: 1,
      marginTop: tokens.spacing.SPACING_8,
      marginBottom: tokens.spacing.SPACING_8
    },
    imageContainer: {
      alignItems: 'center',
      flexDirection: 'row',
      flex: 1
    },
    imageStyle: {
      marginRight: tokens.spacing.SPACING_12,
      borderRadius: withRoundImage ? 28 : 0,
      height: 56,
      width: 56
    }
  });
};